module.exports = __webpack_public_path__ + "static/media/Movement Concluded.d869b988.svg";